const iframeStyle = {
  width: "100%",
  minHeight: "80vh",
};
const Test = () => {
  return (
    <>
      <iframe
        src="https://translater-qpjoej.firebaseapp.com/"
        title="Victor"
        style={iframeStyle}
      ></iframe>
    </>
  );
};

export default Test;
